import React from 'react';
import { Form, Input } from 'antd';
import { type SizeType } from 'antd/es/config-provider/SizeContext';

type propsType = {
  id?: string;
  className?: string;
  name?: string;
  label?: React.ReactNode;
  required?: boolean;
  requiredMessage?: string;
  patternMessage?: string;
  placeholder?: string;
  prefix?: any;
  suffix?: any;
  offset?: number;
  span?: number;
  allowClear?: boolean;
  type?: string;
  ruleType?: any;
  defaultValue?: any;
  maxLength?: number;
  showCount?: boolean;
  disabled?: boolean;
  readonly?: boolean;
  value?: any;
  size?: SizeType;
  onFocus?: any;
  onBlur?: any;
  onKeyUp?: any;
  onKeyDown?: any;
  websiteOptions?: any;
  onWebsiteChange?: any;
  pattern?: any;
  status?: '' | 'error' | 'warning';
  show?: boolean;
  ref?: any;
  style?: any;
  onChange?: any;
};

const IyeInput: React.FC<propsType> = ({ onChange, ...propsType }) => {
  return (
    <Form.Item
      label={propsType.label}
      name={propsType.name}
      className={propsType.className}
      rules={[
        {
          required: propsType.required,
          message: propsType.requiredMessage,
        },
        {
          type: propsType.ruleType,
          message:
            propsType.patternMessage ??
            'Input does not match the expected format.',
          pattern:
            propsType.pattern &&
            typeof propsType.pattern === 'string' &&
            propsType.pattern.trim() !== ''
              ? new RegExp(propsType.pattern.trim())
              : /^[A-Za-z0-9].*$/,
        },
      ]}
      wrapperCol={{ offset: propsType.offset, span: propsType.span }}
    >
      <Input
        {...propsType}
        onChange={onChange}
        style={{
          minHeight: 50,
          borderRadius: 999,              // pill shape
          boxShadow: '0 2px 8px rgba(0,0,0,0.08)', // soft shadow
          paddingLeft: 16,
          paddingRight: 16,
          ...propsType.style,             // allow override
        }}
      />
    </Form.Item>
  );
};

export default IyeInput;